import * as React from 'react';
import { withRouter } from 'react-router-dom';
import Box from '@mui/material/Box';
import Avatar from 'components/v2/PageElements/Avatar';
import PersonIcon from '@mui/icons-material/Person';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Logout from '@mui/icons-material/ExitToApp';
import DesktopWindowsIcon from '@mui/icons-material/DesktopWindows';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { useAppContext } from 'components/v2/AppContext';

const AccountMenu = ({ history, ...props }) => {
  const { profile, permissions, paths } = useAppContext();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const { myHomePath, manageHomePath, logoutPath, labsDisable } = paths;

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <React.Fragment>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip title="Account settings">
          <IconButton onClick={handleClick} size="small" sx={{ ml: 2 }}>
            <Avatar {...{ profile }} />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {permissions.profile.isAnyAdmin && (
          <>
            <MenuItem onClick={() => history.push(myHomePath)}>
              <ListItemIcon>
                <PersonIcon fontSize="large" />
              </ListItemIcon>
              My ThreatSwitch
            </MenuItem>

            <MenuItem onClick={() => history.push(manageHomePath)}>
              <ListItemIcon>
                <SupervisorAccountIcon fontSize="large" />
              </ListItemIcon>
              Management Console
            </MenuItem>
          </>
        )}
        <MenuItem onClick={() => history.push(labsDisable)}>
          <ListItemIcon>
            <DesktopWindowsIcon fontSize="large" />
          </ListItemIcon>
          ThreatSwitch Classic
        </MenuItem>

        <Divider />
        <MenuItem onClick={() => history.push(logoutPath)}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
};

export default withRouter(AccountMenu);
